import { HttpLink } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { AuthenticationResult } from "@azure/msal-browser";

export const getApolloHttpLink = (endpoint: string): HttpLink => {
  return new HttpLink({
    uri: endpoint,
    credentials: "same-origin",
  });
};

export const getAuthLink = (token: AuthenticationResult) =>
  setContext(async (_, { headers }) => {
    // return the headers to the context so httpLink can read them
    return {
      headers: {
        ...headers,
        Authorization: "Bearer " + token?.accessToken,
      },
    };
  });
